import React from 'react';

import { IconProps } from './types';

export const PhoneIcon = React.forwardRef<SVGSVGElement, IconProps>((props, forwardedRef) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22.695"
    height="22.682"
    viewBox="0 0 22.695 22.682"
    ref={forwardedRef}
    {...props}
  >
    <g id="phone-receiver" transform="translate(0 -0.188)">
      <g id="Group_190" data-name="Group 190" transform="translate(0 0.188)">
        <path
          id="Path_540"
          data-name="Path 540"
          d="M22.684,18.087a1.1,1.1,0,0,1-.336.961l-3.2,3.171a1.8,1.8,0,0,1-.565.408,2.333,2.333,0,0,1-.685.216q-.024,0-.144.012t-.312.012a11.076,11.076,0,0,1-1.478-.156,11.222,11.222,0,0,1-2.5-.769,20.974,20.974,0,0,1-3.352-1.838,24.989,24.989,0,0,1-3.988-3.364A26.327,26.327,0,0,1,3.344,13.57a22.6,22.6,0,0,1-1.778-2.8A15.075,15.075,0,0,1,.557,8.441,12.365,12.365,0,0,1,.1,6.639,5.951,5.951,0,0,1,0,5.45q.024-.432.024-.481a2.335,2.335,0,0,1,.216-.685A1.8,1.8,0,0,1,.653,3.72l3.2-3.2A1.058,1.058,0,0,1,4.617.188a.9.9,0,0,1,.553.18,1.67,1.67,0,0,1,.408.444L8.149,5.69a1.169,1.169,0,0,1,.12.841A1.5,1.5,0,0,1,7.86,7.3L6.683,8.477a.4.4,0,0,0-.084.156.593.593,0,0,0-.036.18A4.338,4.338,0,0,0,7,9.967a10.586,10.586,0,0,0,.889,1.406,15.606,15.606,0,0,0,1.706,1.91A15.914,15.914,0,0,0,11.512,15a11.1,11.1,0,0,0,1.406.9,3.736,3.736,0,0,0,.865.348l.3.06a.573.573,0,0,0,.156-.036.4.4,0,0,0,.156-.084L15.765,14.8a1.472,1.472,0,0,1,1.009-.384,1.255,1.255,0,0,1,.649.144h.024l4.637,2.739A1.209,1.209,0,0,1,22.684,18.087Z"
          transform="translate(0 -0.188)"
          fill="#707070"
        />
      </g>
    </g>
  </svg>
));
PhoneIcon.displayName = 'PhoneIcon';

export default PhoneIcon;
